// istanbul ignore file
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface AssetAlarmState {
  isLoading: boolean
  error: string | undefined
  data: any | null
  httpStatus: number | undefined
}

export const initialState: AssetAlarmState = {
  isLoading: false,
  error: undefined,
  data: null,
  httpStatus: 0
}

const addAssetKpiAlarmSlice = createSlice({
  name: 'addAssetKpiAlarmSlice',
  initialState,
  reducers: {
    addAssetKpiAlarmLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: null,
        httpStatus: 0
      }
    },
    addAssetKpiAlarmUpdateAction: (state, action: PayloadAction<{ data: any, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    addAssetKpiAlarmErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: null,
        httpStatus: action.payload.httpStatus
      }
    },
    assetAlarmReset: () => initialState
  }
})

export const {
  addAssetKpiAlarmLoadingAction,
  addAssetKpiAlarmUpdateAction,
  addAssetKpiAlarmErrorAction,
  assetAlarmReset
} = addAssetKpiAlarmSlice.actions

export default addAssetKpiAlarmSlice.reducer
